import React, { useState } from 'react';
import { Instagram, Facebook, Mail, MapPin, Phone } from 'lucide-react';
import { LegalModal, PrivacyContent, TermsContent } from './LegalModal';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-charcoal text-white/80 pt-20 pb-10 border-t border-white/10" data-id="element-22">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-23">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-24">
            {/* Brand Column */}
            <div className="lg:col-span-1" data-id="element-25">
              <div className="flex items-center gap-3 mb-6" data-id="element-26">
                <div className="w-10 h-10 rounded bg-white overflow-hidden p-1" data-id="element-27">
                  <img src="https://cdn.magicpatterns.com/uploads/hvr54fUgpvRXPZnwmrPfcj/grandtown_logo.jpg" alt="Grand Town Logo" className="w-full h-full object-cover rounded-sm" data-id="element-28" />
                </div>
                <span className="font-playfair font-semibold text-xl text-white" data-id="element-29">
                  Grand Town
                </span>
              </div>
              <p className="text-sm leading-relaxed mb-6 text-white/60" data-id="element-30">
                Administración integral y ventas de alto nivel en Playa del
                Carmen. Maximizamos el valor de su patrimonio con absoluta
                transparencia.
              </p>
              <div className="flex gap-4" data-id="element-31">
                <a href="https://www.instagram.com/grandtown.inmo.admin/" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gold hover:text-white transition-colors duration-300" data-id="element-32">
                  <Instagram size={18} data-id="element-33" />
                </a>
                <a href="https://www.facebook.com/people/Grand-Town-Inmobiliaria-Administraci%C3%B3n/61580891741392/" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gold hover:text-white transition-colors duration-300" data-id="element-34">
                  <Facebook size={18} data-id="element-35" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-36">
              <h4 className="text-white font-playfair font-semibold text-lg mb-6" data-id="element-37">
                Enlaces Rápidos
              </h4>
              <ul className="space-y-4 text-sm" data-id="element-38">
                <li data-id="element-39">
                  <a href="#inicio" className="hover:text-gold transition-colors" data-id="element-40">
                    Inicio
                  </a>
                </li>
                <li data-id="element-41">
                  <a href="#servicios" className="hover:text-gold transition-colors" data-id="element-42">
                    Servicios
                  </a>
                </li>
                <li data-id="element-43">
                  <a href="#nosotros" className="hover:text-gold transition-colors" data-id="element-44">
                    Nosotros
                  </a>
                </li>
                <li data-id="element-45">
                  <a href="#contacto" className="hover:text-gold transition-colors" data-id="element-46">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div data-id="element-47">
              <h4 className="text-white font-playfair font-semibold text-lg mb-6" data-id="element-48">
                Servicios
              </h4>
              <ul className="space-y-4 text-sm" data-id="element-49">
                <li data-id="element-50">
                  <a href="#servicios" className="hover:text-gold transition-colors" data-id="element-51">
                    Administración de Lujo
                  </a>
                </li>
                <li data-id="element-52">
                  <a href="#servicios" className="hover:text-gold transition-colors" data-id="element-53">
                    Compraventa Estratégica
                  </a>
                </li>
                <li data-id="element-54">
                  <a href="#servicios" className="hover:text-gold transition-colors" data-id="element-55">
                    Gestión de Rentas Premium
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div data-id="element-56">
              <h4 className="text-white font-playfair font-semibold text-lg mb-6" data-id="element-57">
                Contacto
              </h4>
              <ul className="space-y-4 text-sm" data-id="element-58">
                <li className="flex items-start gap-3" data-id="element-59">
                  <MapPin size={18} className="text-gold shrink-0 mt-0.5" data-id="element-60" />
                  <span data-id="element-61">Playa del Carmen, Quintana Roo, México</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-62">
                  <Phone size={18} className="text-gold shrink-0" data-id="element-63" />
                  <span data-id="element-64">+52 984 311 5669</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-65">
                  <Mail size={18} className="text-gold shrink-0" data-id="element-66" />
                  <span data-id="element-67">contacto@grandtown.com</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40" data-id="element-68">
            <p data-id="element-69">
              &copy; {currentYear} Grand Town Inmobiliaria & Administración.
              Todos los derechos reservados.
            </p>
            <div className="flex gap-6" data-id="element-70">
              <button onClick={() => setPrivacyOpen(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-71">
                Aviso de Privacidad
              </button>
              <button onClick={() => setTermsOpen(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-72">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Aviso de Privacidad" data-id="element-73">
        <PrivacyContent data-id="element-74" />
      </LegalModal>

      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-75">
        <TermsContent data-id="element-76" />
      </LegalModal>
    </>;
}